const isAffirmNeeded = componentData =>
  componentData && componentData.some(c => {
    if (c.internal && c.internal.type === "ContentfulPurchaseForm") {
      return !(c.hideInstallmentPaymentOption && c.hideInstallmentPaymentOption === true)
    }

    return Object.entries(c).some(entry => {
      let [, value] = entry
      if (value && typeof value === "object") {
        // Convert object to array before passing back into function
        if (!Array.isArray(value)) {
          value = Object.keys(value).map(key => ({ [key]: value[key] }))
        }
        return isAffirmNeeded(value)
      }

      return false
    })
  })

module.exports = isAffirmNeeded
